<script lang="ts">
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import type { SbColor } from '../types';
	import { editable } from '../editable';
	import SbRichtext from '../components/sbRichtext.svelte';
	import PageGrid16 from '../components/pageGrid16.svelte';

	interface Props {
		content: ISbStoryData<{
			headline: ISbRichtext;
			paragraph: ISbRichtext;
			bg_color: SbColor;
			headline_color: SbColor;
			paragraph_color: SbColor;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<PageGrid16 class="my-12">
	<section
		use:editable={content}
		class={`bg-${content.bg_color} col-span-full flex px-5 py-14 max-lg:flex-col max-lg:gap-y-5 lg:col-start-2 lg:col-end-[16] lg:gap-x-17 lg:rounded-xl lg:px-21 lg:py-17`}
	>
		<div
			class={`flex-1 text-${content.headline_color} text-[36px]/[112%] tracking-[-.36px] lg:text-[48px]/[120%] lg:tracking-[-.48px]`}
		>
			<SbRichtext text={content.headline} />
		</div>
		<div class={`flex-1 text-${content.paragraph_color} text-[14px]/[160%] lg:text-[16px]/[150%]`}>
			<SbRichtext text={content.paragraph} />
		</div>
	</section>
</PageGrid16>
